import { css } from 'aphrodite';
import * as React from 'react';
import { LeadRuleViewModel } from '../../../viewModels/leadrules';
import { friendlyWeeklySchedule } from '../../LeadRuleModal/utils';
import { styleSheet } from '../styles';

interface IProps {
	leadRule: LeadRuleViewModel;
}

export const RuleSchedule: React.FC<IProps> = ({ leadRule }) => {
	const isAlwaysOn = leadRule?.recurrence === 'AlwaysOn';
	const isSingleInterval = leadRule?.recurrence === 'SingleInterval';
	const isWeekly = leadRule?.recurrence === 'Weekly';

	const weeklySchedule = leadRule?.weeklySchedule;

	const intervals =
		isWeekly &&
		weeklySchedule
			?.map(friendlyWeeklySchedule)
			?.filter(i => !!i)
			.join(', ');

	if (isAlwaysOn) {
		return null;
	}

	return (
		<div className={css(styleSheet.scheduleLine)}>
			{!leadRule.isExpired && <p className={css(styleSheet.scheduleTitle)}>Schedule:</p>}
			{isSingleInterval &&
				(leadRule.isExpired ? (
					<span className={css(styleSheet.expired)}>EXPIRED</span>
				) : (
					<span>
						{leadRule?.scheduleMin} to {leadRule?.scheduleMax}
					</span>
				))}
			{isWeekly && <span>Weekly: {intervals}</span>}
		</div>
	);
};
